import React, { useState, useMemo, useCallback, useEffect, useContext } from "react";
import {
    Select,
    FormControl,
    MenuItem,
    InputLabel,
} from "@material-ui/core";
import "./FinalCommentaryOverallCategory.scss";
import { columnNames, columnNamesOtherFormat } from "./columnNames";
import { useDropzone } from "react-dropzone";
import Loader from "../../../../Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { toast, Flip } from "react-toastify";
import readXlsxFile from "read-excel-file";
import * as myConsts from "../../../../../constants/constants";
import AppContext from "../../../../../utils/appContext";
import ReportDownload from '../../ReportDownload';
import {
    authProvider,
    GraphExplorerscopes,
} from "../../../../../Authentication/authProvider";
import NoAccess from "../../../../NotValidUser/NoAccess";

const FinalCommentaryOverallCategory = (props) => {
    const {
        reportApi,
        currentPeriod,
        currentYear,
        dropdownValue,
        appliedFilterList,
    } = props;
    const dispatch = useDispatch();

    const userPermission = sessionStorage.getItem('userPermission')
        ? JSON.parse(sessionStorage.getItem('userPermission'))
        : null;
    const isBulkOverallCategory = userPermission?.appAuthorization?.isBulkOverallCategory;

    const myContext = useContext(AppContext);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [firstTime, setFirstTime] = useState(true);
    const [headerErrors, setHeaderError] = useState(false);
    const [progress, setProgress] = useState(-1);
    const [enableProgress, setEnableProgress] = useState(false);
    const [popupType, setPopUpType] = useState(-1);
    const [fileInfo, setFileInfo] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [issueFields, setIssueFields] = useState(null);
    const [disableBulkUpload, setBulkUpload] = useState(false);

    const bulkUploadDiscussionGuide = useSelector((state) => state.saveMultiUsersOverallCategory);
    const bobAdminActionStatus = useSelector((state) => state.bobAdminActionStatus);

    const [financialYear, setFinancialYear] = useState(myContext.financialYear);
    const [region, setRegion] = useState("--Select Region--");
    const [filterRegion, setFilterRegion] = useState({});

    const [timePeriod, setTimePeriod] = useState(
        myContext.activePeriod
            ? myContext.activePeriod
            : myConsts.TimePeriodsArray[0]
    );

    const handleRegion = (e) => {
        //debugger;
        let regionList = JSON.parse(JSON.stringify(filterRegion));
        regionList && regionList.region && Array.isArray(regionList.region)
            && regionList.region.map((r, i) => {
                if (r.name === e.target.value) {
                    regionList.region[i].isSelected = true;
                } else {
                    regionList.region[i].isSelected = false;
                }
            });
        setRegion(e.target.value);
        setFilterRegion(regionList);
    }

    const { getRootProps, getInputProps, fileRejections } = useDropzone({
        onDrop: (files) => {
            setHeaderError(false);
            validateFile(files[0]);
        },
        maxFiles: 1,
        maxSize: 15728640,
        accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet ,application/vnd.ms-excel.sheet.binary.macroEnabled.12",
        disabled: disableBulkUpload
    });

    const validateFile = useCallback((file) => {
        if (!file) {
            return;
        } else {
            setFileInfo(file);
            setIsPopupVisible(true);
            setPopUpType(0);
        }
    }, []);

    useEffect(() => {
        if (progress < 100) {
            setTimeout(function () {
                if (progress == 98 && !isLoading && !headerErrors) {
                    setProgress(100);
                } else setProgress(progress + 2);
            }, 1);
        }
    }, [progress]);

    useEffect(() => {
        const fileRejectionItems = fileRejections.map(({ errors }) => {
            return errors.map((e) => e.code);
        });
        if (fileRejectionItems.length > 0) {
            if (fileRejectionItems[0].includes("file-too-large"))
                notify(
                    "File size is too large. File size should be within 15MB.",
                    "error"
                );
            else if (fileRejectionItems[0].includes("file-invalid-type"))
                notify(
                    "File type is not valid.Only,excel file with .xlsx extension can be uploaded. ",
                    "error"
                );
            else notify(fileRejectionItems[0], "error");
        }
    }, [fileRejections]);

    const fileHandler = useCallback(() => {
        setIsLoading(true);
        readXlsxFile(fileInfo).then((rows) => {
            validateExcelData(rows);
            console.log(rows);
            setIsLoading(false);
        }).catch(() => { });
    }, [fileInfo, validateExcelData]);

    const validateExcelData = useCallback((rows) => {
        //debugger;
        setErrorMsg("");
        setIssueFields(null);
        setHeaderError(false);
        const updatedRows = _.cloneDeep(rows);
        updatedRows.shift();

        let isEmpty = false;

        if (!_.isEqual(columnNames, rows[0]) && !_.isEqual(columnNamesOtherFormat, rows[0])) {
            setErrorMsg(
                "The file which you have uploaded is not in the correct format."
            );
            setHeaderError(true);
            return;
        } else if (updatedRows.length === 0) {
            setErrorMsg("File which you uploaded has blank cells.");
            setHeaderError(true);
            return;
        } else {
            let emptyCellList = [], invalidFieldValues = [];
            updatedRows.forEach((updatedRow, rowIndex) => {
                updatedRow.forEach((row, columnIndex) => {
                    if ((row === "" || row === null)) {
                        isEmpty = true;
                        emptyCellList.push({ column: columnNames[columnIndex], rowNo: rowIndex + 2 });
                    }
                });
            });
            if (isEmpty) {
                setErrorMsg("File contains below number of blank cells, please validate and upload again.");
                setHeaderError(true);
                const groupedResult = _.groupBy(emptyCellList, x => x.column);
                setIssueFields(groupedResult);
                return;
            }
        }
    }, []);


    const notify = useCallback((msg, type) => {
        toast(
            <div className="error-text">
                {type === "error" ? (
                    <span className="icon-close-filled icon"></span>
                ) : (
                    <span className="eyaa-state-36 icon"></span>
                )}
                <p>
                    {type === "error" ? (
                        <>
                            <span>Error:</span> <span>{msg}</span>
                        </>
                    ) : (
                        <span>{msg}</span>
                    )}
                </p>
            </div>,
            {
                className: type,
                position: "top-center",
                transition: Flip,
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            }
        );
    }, []);

    const discussionGuideFileToUpload = async () => {
        try {
            const financialYear = currentYear.split(" ")[1];
            const idtoken = await authProvider.acquireTokenSilent({
                scopes: GraphExplorerscopes,
            });
            const token = idtoken.accessToken;
            dispatch({
                type: "SAVE_MULTI_USERS_OVERALL_CATEGORY",
                payload: {
                    ad_token: token,
                    save_multi_users_overall_category_upload: fileInfo,
                    financialYear: financialYear,
                    phase: myConsts.TimePeriodYearEnd,
                    region: region
                },
            });
            setIsLoading(true);
        } catch (e) {
            console.error(e);
        }
    };

    const getLockStatusAPI = async () => {
        //function to call bobAdminActionStatus(Lock) Api.
        try {
            if (financialYear !== "" && timePeriod !== "") {
                dispatch({
                    type: "BOB_ADMIN_ACTION_STATUS",
                    payload: {
                        financialYear: financialYear,
                        timePeriod: timePeriod,
                    },
                });
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        //bulkUploadDiscussionGuide  API response
        //debugger;
        if (
            !bulkUploadDiscussionGuide.fetching &&
            bulkUploadDiscussionGuide.data &&
            bulkUploadDiscussionGuide.data.success
        ) {
            setIsLoading(false);
            toast.warn(
                <div>
                    <i className="icon-verified-outline" />
                    {"Success"}
                    <b> {": "}</b>
                    {"File Uploaded Successfully"}
                </div>,
                {
                    position: "top-center",
                    transition: Flip,
                    autoClose: 1500,
                    hideProgressBar: true,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                }
            );
            dispatch({
                type: "SAVE_MULTI_USERS_OVERALL_CATEGORY_RESET",
                payload: {},
            });

            getLockStatusAPI();
            props.history.push(myConsts.routeAdmin);
        } else if (
            !bulkUploadDiscussionGuide.fetching &&
            bulkUploadDiscussionGuide.data &&
            bulkUploadDiscussionGuide.data.success === false
        ) {
            setIsLoading(false);
            toast.warn(
                <div>
                    <i className="icon-warning-outline" />
                    <b> {": "}</b>
                    {"Discussion Guide File Upload has Failed"}
                </div>,
                {
                    position: "top-center",
                    transition: Flip,
                    autoClose: 1500,
                    hideProgressBar: true,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                }
            );

            dispatch({
                type: "BULK_UPLOAD_DISCUSSION_GUIDE_RESET",
                payload: {},
            });
        }
    }, [bulkUploadDiscussionGuide]);

    useEffect(() => {
        //lock status API response
        if (
            !bobAdminActionStatus.fetching &&
            bobAdminActionStatus.data &&
            bobAdminActionStatus.data.bobStatus &&
            bobAdminActionStatus.data.proceedAction
        ) {
            //Succefully Completed
            setIsLoading(false);
            setBulkUpload(false);
        } else if (
            !bobAdminActionStatus.fetching &&
            bobAdminActionStatus.data &&
            bobAdminActionStatus.data.bobStatus &&
            !bobAdminActionStatus.data.proceedAction
        ) {
            //not completed
            if (firstTime) {
                triggerLock();
                setFirstTime(false);
                setIsLoading(false);
            }

            setBulkUpload(true);
            setTimeout(function () {
                getLockStatusAPI();
            }, 15000);
        }
    }, [bobAdminActionStatus]);

    useEffect(() => {
        getLockStatusAPI();
        //debugger;
        let filterList = JSON.parse(JSON.stringify(appliedFilterList));
        setFilterRegion(filterList);
    }, [appliedFilterList]);

    const triggerLock = () => {
        toast.warn(
            <div
                style={{
                    // textTransform: "capitalize",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "EYInterState-Regular",
                    fontSize: "12px",
                }}>
                <i className="icon-warning-outline" />
                {/* "Section Updated Successfully" : */}
                {`Previous operation initiated by ${bobAdminActionStatus.data.userName} is still in progress. It will take some time. You can
                perform this action after the operation is completed. We appreciate your
                patience!`}
            </div>,
            {
                position: "top-center",
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            }
        );
    };

    return (
        <>
            {isLoading && <Loader />}
            {
                isBulkOverallCategory ? (
                    <>
                        <div className="multiple-overall-category-data-management-container"
                            style={{ maxHeight: '350px', overflowY: "scroll", overflowX: "hidden", padding: "10px" }}>
                            <div className="input-container">
                                <div className="select-container"
                                    style={{ marginTop: "10px" }}>
                                    <FormControl>
                                        <InputLabel id="yearLabel">Select Region</InputLabel>
                                        <Select
                                            MenuProps={{
                                                anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "left",
                                                },
                                                transformOrigin: {
                                                    vertical: "top",
                                                    horizontal: "left",
                                                },
                                                getContentAnchorEl: null,
                                            }}
                                            labelId="yearLabel"
                                            value={region}
                                            onChange={(e) => {
                                                handleRegion(e);
                                            }}
                                        >
                                            {props.filterList.map((value, key) => (
                                                <MenuItem value={value} key={key}>
                                                    {value}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            {/* <div className="input-container">
                    {
                        region !== "--Select Region--" && (
                            <div>
                                <div className="download-template">
                                    <ReportDownload
                                        reportApi={reportApi}
                                        currentPeriod={currentPeriod}
                                        currentYear={currentYear}
                                        dropdownValue={dropdownValue}
                                        appliedFilterList={filterRegion}
                                        isFromOverallCategoryBulkUpload={true}
                                    />
                                </div>
                                <p className="info-text" style={{
                                    color: "#0000ee",
                                    fontFamily: "EYInterState-Regular",
                                    fontStyle: "italic"
                                }}>
                                    * Important Note:- Download the template to make edits and upload the updated file here.
                                </p>
                            </div>
                        )
                    }
                </div> */}
                            {
                                region !== "--Select Region--" && (
                                    <section
                                        style={{ opacity: disableBulkUpload || (progress > 0 && progress < 100) || (progress === 100) ? 0.5 : 1 }}>
                                        <div className="file-upload-container" {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            <div className="helper-text">
                                                <p>Drag your file here to Upload</p>
                                                <p>Maximum file size: 15MB</p>
                                            </div>
                                            <label htmlFor="uploadFile" style={{ cursor: disableBulkUpload || (progress > 0 && progress < 100) || (progress === 100) ? "not-allowed" : "pointer" }}>
                                                {" "}
                                                <span className="eyaa-files-104 file-icon"></span>{" "}
                                                <span>Choose file</span>
                                            </label>
                                        </div>
                                    </section>
                                )
                            }

                            {/* progressLine */}
                            {enableProgress && region !== "--Select Region--" && (
                                <div
                                    className="shadowBox"
                                    style={{
                                        borderLeftColor: `${progress === 100 ? "#b1de76" : "#2e2e38"}`,
                                    }}
                                >
                                    <div className="title">
                                        {progress === 100 ? "Validation Completed" : "Validating file"}
                                        {headerErrors && <div className="errorMsg">{"File Error"}</div>}
                                    </div>
                                    {progress !== 100 ? (
                                        <div className="blackLine">
                                            <div
                                                className="yelloLine"
                                                style={{ left: `${(progress / 100) * 330}px` }}>
                                                {"&nbsp;"}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="greenLine">{"&nbsp;"}</div>
                                    )}
                                    <div className="row">
                                        <div className="fileN"> {fileInfo.name}</div>
                                        <div className="progress">
                                            {" "}
                                            {progress +
                                                " % " +
                                                (progress === 100 ? "Complete" : "Processing...")}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {headerErrors && region !== "--Select Region--" && (
                                <div className="error-section">
                                    <span className="redMsg">
                                        {" "}
                                        <i className="icon-warning-filled" />
                                        File Error
                                    </span>
                                    <div className="desc">
                                        {errorMsg}
                                    </div>
                                    {issueFields ?
                                        <div className="blank-counts">
                                            {Object.keys(issueFields).map(key => <div className="counts">{`${key} (${issueFields[key].length})`}</div>)}
                                        </div> : null}
                                </div>
                            )}
                            {
                                region !== "--Select Region--" && (
                                    <div className="AdminActions">
                                        <>
                                            <div
                                                className="cancel"
                                                onClick={() => {
                                                    props.history.push(myConsts.routeAdmin);
                                                }}
                                            >
                                                Cancel
                                            </div>

                                            <div
                                                className={
                                                    "save" +
                                                    (!headerErrors &&
                                                        progress === 100 &&
                                                        !disableBulkUpload
                                                        ? ""
                                                        : " disable-btn ")
                                                }
                                                onClick={() => {
                                                    setIsPopupVisible(true);
                                                    setPopUpType(1);
                                                }}
                                            >
                                                Save
                                            </div>
                                        </>
                                    </div>
                                )
                            }
                        </div>
                        {/* popUpPage */}
                        {
                            isPopupVisible && (
                                <div className="popup-dialog">
                                    <div className="dialog">
                                        <div className="header">
                                            <h5>{popupType == 0 ? "File Validation" : "Confirmation"}</h5>
                                            <span
                                                style={{ position: "absolute", right: "12px", top: "10px" }}
                                                className="icon-close-filled icon"
                                                onClick={() => setIsPopupVisible(false)}
                                            ></span>
                                        </div>
                                        {popupType == 0 ? (
                                            <div className="content">
                                                <span>Selected file</span>
                                                <b> {fileInfo.name}</b>
                                                <span> should be validated before uploading.</span>
                                            </div>
                                        ) : (
                                            <div className="content">Would you like to update the overall category data? </div>
                                        )}
                                        {popupType == 1 && (
                                            <div className="content" style={{ marginTop: "10px" }}>
                                                Please note that this will take some time.
                                            </div>
                                        )}
                                        {popupType == 0 ? (
                                            <div className="footer">
                                                <button
                                                    className="cancel-btn"
                                                    onClick={() => {
                                                        setIsPopupVisible(false);
                                                        setEnableProgress(false);
                                                        setFileInfo(null);
                                                        setHeaderError(false);
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    className="validate-btn"
                                                    onClick={() => {
                                                        setEnableProgress(true);
                                                        setIsPopupVisible(false);
                                                        setProgress(0);
                                                        fileHandler();
                                                        setHeaderError(false);
                                                    }}
                                                >
                                                    Validate
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="footer">
                                                <button
                                                    className="cancel-btn"
                                                    onClick={() => {
                                                        setIsPopupVisible(false);
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    className="validate-btn"
                                                    onClick={() => {
                                                        setIsPopupVisible(false);
                                                        setEnableProgress(false);
                                                        setBulkUpload(true);
                                                        discussionGuideFileToUpload();
                                                        dispatch({
                                                            type: "BOB_ADMIN_ACTION_STATUS_RESET",
                                                            payload: {},
                                                        });
                                                    }}
                                                >
                                                    Confirm
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )
                        }
                    </>
                )
                    :
                    (
                        <NoAccess {...props} />
                    )
            }

        </>
    );
};

export default FinalCommentaryOverallCategory;
